export default "__VITE_ASSET__DYwUw7bZ__"